import {
	Component,
	OnInit,
	AfterViewInit,
	OnDestroy,
	ViewChildren,
	ElementRef
} from "@angular/core";
import { Subscription, Observable, fromEvent } from "rxjs";
import { FormBuilder, FormControlName, FormGroup } from "@angular/forms";

import {
	GlobalDataOpsService,
	GlobalDomOpsService,
	AcepSSOService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	DomService,
	DataService,
	LoggerService,
	HelperService
} from "../../../core/services";
import { MemberAppDataService, MemberAppDomService } from "../../services";
import { PersonalInfoService } from "../personal-info/personal-info.service";
import { MembershipService } from "../membership/membership.service";
import { EducationService } from "../education/education.service";
import { ChangeAddressService } from "../change-address/change-address.service";
import { ChaptersService } from "../chapters/chapters.service";
import { Location } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { DEFAULT_RESIZE_TIME } from "@angular/cdk/scrolling";
import { SectionsService } from "../sections/sections.service";

@Component({
	selector: "app-memberapp-base",
	template: ""
})
export class MemberappBaseComponent
	implements OnInit, AfterViewInit, OnDestroy {
	@ViewChildren(FormControlName, { read: ElementRef })
	formInputElements: ElementRef[];

	public subscriptions: Array<Subscription> = [];
	public formSubmitted: boolean = false;
	public errorMessage: string = "";
	public isDevEnv: boolean = false; // !environment.production;

	constructor(
		public globalDataOpsService: GlobalDataOpsService,
		public globalDomOpsService: GlobalDomOpsService,
		public commonOpsService: CommonOperationsService,
		public ssoService: AcepSSOService,
		public dataService: DataService,
		public domService: DomService,
		public helperService: HelperService,
		public memberAppDataService: MemberAppDataService,
		public memberAppDomService: MemberAppDomService,
		public personalInfoService: PersonalInfoService,
		public membershipService: MembershipService,
		public educationService: EducationService,
		public chaptersService: ChaptersService,
		public sectionsService: SectionsService,
		public changeAddressService: ChangeAddressService,
		public loggerService: LoggerService,
		public location: Location,
		public fb: FormBuilder
	) { }

	ngOnInit() { }

	ngAfterViewInit() {
		this.globalDomOpsService.hidewait();

		// Watch for the blur event from any input element on the form.
		// let controlBlurs: Observable<any>[] = this.formInputElements
		// .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
			subscription.unsubscribe();
		});
	}

	onError() {
		this.globalDomOpsService.notify("Internal Server Error", "", "error");
		this.loggerService.logError(this.errorMessage);
	}

	onSave(formGroup: FormGroup) {
		this.formSubmitted = true;
		this.helperService.markFormGroupTouched(formGroup);

		this.loggerService.logInfo(formGroup.value);
		this.loggerService.logInfo(`page is ${formGroup.status}`);

		if (formGroup.invalid) {
			let allErrors = this.helperService.getAllErrors(formGroup);
			this.loggerService.logError(JSON.stringify(allErrors));
			this.domService.scrollToFirstError();
		}
	}
}
